import Portfolio from "../../components/Portfolio"
export default function PortfolioPage() {
    return (
        <div
        style={{display:"flex"}}>
        <Portfolio/>
        </div>
    )
}
